import { m, type MithrilVNode } from '../../mithril';
import { CSS } from './collapsible.style';
import type { PanelCollapseState } from './panel.collapse.state';

/** Carries the panel's title on its side so the user can still tell what is hidden behind it. */
export const CollapsedRail = {
	view(state: PanelCollapseState, label: string): MithrilVNode {
		if (!state.isCollapsed) {
			return null;
		}

		return m('div', { className: CSS.rail }, [
			state.viewToggle(),
			m('div', { className: CSS.railLabel, title: label }, label),
		]);
	},
};
